if (!Array.prototype.at) {
  // oxlint-disable-next-line no-extend-native -- this file's entire purpose is the polyfill
  Array.prototype.at = function at(index) {
    index = Math.trunc(index) || 0;
    if (index < 0) {
      index += this.length;
    }
    if (index < 0 || index >= this.length) {
      return undefined;
    }
    return this[index];
  };
}
